<template>
    <!-- Start Boxes Area -->
    <section class="boxes-area">
        <div class="container">
            <div class="row">
<!--                <div class="col-lg-3 col-md-6 col-sm-6">-->
<!--                    <div class="single-box">-->
<!--                        <div class="icon">-->
<!--                            <feather type="server"></feather>-->
<!--                        </div>-->
<!--                        <h3>Server</h3>-->
<!--                        <p>Můžete použít své nebo naše servery.</p>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-box bg-f78acb">
                        <div class="icon">
                          <feather type="users"></feather>
                        </div>
                        <h3>Individuální přístup</h3>
                        <p>Lindosoft nabízí komplexní služby v oblasti vývoje softwaru, které začínají úzkou spoluprací s každým zákazníkem a vytvářením individuálního návrhu řešení. Tento návrh je pečlivě připraven tak, aby plně odpovídal specifickým potřebám zákazníka a současně respektoval jeho rozpočet a časové limity.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-box bg-c679e3">
                        <div class="icon">
                          <feather type="code"></feather>
                        </div>
                        <h3>Technologie</h3>
                        <p>Jsme IT firmou specializující se na vývoj moderních webových aplikací s použitím technologií Java, Spring Boot, MySQL, Docker a VueJS apod. S našimi odbornými znalostmi a zkušenostmi jsme připraveni vytvořit pro vás aplikaci, která plně odpovídá vašim specifickým požadavkům a potřebám.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="single-box bg-eb6b3d">
                        <div class="icon">
                            <feather type="git-branch"></feather>
                        </div>
                        <h3>Kód verzujeme</h3>
                        <p>Vývoj softwaru je pro nás vážná záležitost a snažíme se být co nejprofesionálnější. Proto kód našich aplikací verzujeme a ukládáme do repozitáře, což zajišťuje jeho bezpečnost a umožňuje nám snadnější správu projektů. Verzování kódu také usnadňuje spolupráci s našimi zákazníky a zvyšuje efektivitu našeho vývoje softwaru.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Boxes Area -->
</template>

<script>
export default {
    name: 'BoxesArea'
}
</script>
